import React, { FC, useContext } from 'react';

import { CurrencyInput } from '@components/common/form';
import { PlAN_LEVEL } from '@constants/enrollmentList/enrollmentList.constant';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { aptcAmountFieldValue } from '../common/enrollmentUtils';
import { AddOrChangeTxnFormContext } from '../context/AddOrChangeTxnProvider';

const EnrollmentAPTCAmounField: FC = () => {
    const { watch, setValue } = useContext(AddOrChangeTxnFormContext);
    const values = watch();

    const onAptcChange = e => {
        aptcAmountFieldValue(setValue, 'aptcAmount', e.target.value);
    };

    return (
        <CurrencyInput
            // @ts-ignore
            label={{
                wrapperClasses: ['currency-input'],
                labelClasses: [''],
                labelText: 'member.enrollment_list.premiumhistory.aptcAmount',
                showRequired: true,
            }}
            input={{
                id: 'aptcAmount',
                isInputRequired: true,
                type: INPUT_TYPES.TEXT,
                value: values.aptcAmount,
                disabled: values.planLevel === PlAN_LEVEL.CATASTROPHIC,
                dataTestId: 'aptcAmount',
                name: 'aptcAmount',
                placeholder: '',
            }}
            actions={{
                handleChange: e => onAptcChange(e),
            }}
            maskOptions={{
                allowDecimal: true,
                prefix: '',
                decimalLimit: '2',
                integerLimit: 10,
                includeThousandsSeparator: false,
                allowLeadingZeroes: true,
            }}
            showIcon={true}
            showTooltip={false}
        />
    );
};

export default EnrollmentAPTCAmounField;
